import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import {
    SubmitModalButtonsRow,
    SubmitModalContent,
    SubmitModalHeaderRow,
    SubmitModalText
} from "widgets/SubmitModal/ui/styles.ts";
import {FC} from "react";
import {Button} from "@atomaro/ui-kit";

export type SubmitModalProps = {
    isOpen: boolean,
    onClose: () => void,
    onConfirm: () => void,
    onDecline?: () => void,
    title: string,
    subtitle: string,
    submitText?: string,
    declineText?: string,
}

export const SubmitModal: FC<SubmitModalProps> = ({isOpen, onClose, onConfirm, onDecline, title, subtitle, submitText, declineText}) => {
    return (
        <Modal
            isOpen={isOpen}
            centered
            style={{ padding: 0, maxHeight: "100%", width: "90%", maxWidth: "350px", borderRadius: 16 }}
            onClickOverlay={onClose}
        >
            <SubmitModalContent>
                <SubmitModalHeaderRow>
                    <h3>{title}</h3>
                    <svg onClick={onClose} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
                        <rect width="24" height="24" x="0" y="0" />
                        <path d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z" fill="rgb(16,24,40)" fillRule="evenodd" />
                    </svg>
                </SubmitModalHeaderRow>
                <SubmitModalText>
                    {subtitle}
                </SubmitModalText>
                <SubmitModalButtonsRow>
                    <Button
                        onClick={onDecline ? onDecline : onClose}
                        label={declineText ? declineText : "Отмена"}
                        size={"l"}
                        variant={'ghost'}
                        colorScheme={'neutral'}
                    />
                    <Button
                        onClick={onConfirm}
                        label={submitText ? submitText : "Да"}
                        size={"l"}
                    />
                </SubmitModalButtonsRow>
            </SubmitModalContent>
        </Modal>
    );
};

